export const tableHeader = {
  1: 'Nome',
  2: 'Cidade',
  3: 'Consumo médio',
  4: 'Data',
}
